import { type ReactNode, useEffect, useRef, useState } from 'react';

import { REVEAL_DURATION_MS } from '../../interaction-states';

export type HelperPresence = {
  label: ReactNode;
  isExiting: boolean;
};

export const useHelperPresence = (label: ReactNode): HelperPresence => {
  const [shownLabel, setShownLabel] = useState(label);
  const [isExiting, setIsExiting] = useState(false);
  const exitTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    clearTimeout(exitTimer.current);

    if (label) {
      setShownLabel(label);
      setIsExiting(false);
      return;
    }

    setIsExiting(true);
    exitTimer.current = setTimeout(() => setShownLabel(null), REVEAL_DURATION_MS);

    return () => clearTimeout(exitTimer.current);
  }, [label]);

  return { label: shownLabel, isExiting };
};
